import { AccordionItem } from '@carbon/react';
import cx from 'clsx';

import styles from 'theme/features/outputs/components/outputs-accordion-item.module.scss';

const ACCORDION_TYPE_CLASS_NAMES = {
  collaborative: styles['item__collaborative'],
  individual: styles['item__individual'],
  community: styles['item__community'],
  support: styles['item__support'],
  specialty: styles['item__specialty'],
  siteSpecific: styles['item__site-specific']
};

const OutputsAccordionItem = ({ type, title, description, children, isExport = false }) => (
  <AccordionItem
    className={cx(styles.item, ACCORDION_TYPE_CLASS_NAMES[type])}
    title={
      <span>
        <br />
        <h4>
          <strong>{title}</strong>
        </h4>
        <p>{description}</p>
        <br />
      </span>
    }
    {...(isExport && { open: isExport })}
  >
    {children}
  </AccordionItem>
);

export default OutputsAccordionItem;
